import { Component, Input } from '@angular/core'
import { MatProgressBar, ProgressBarMode } from '@angular/material/progress-bar'
import FileUpload from '@ui/FileUpload'

@Component({
	selector: 'upload-progress',
	templateUrl: './UploadProgress.Component.html',
	imports: [MatProgressBar],
})
export class UploadProgressComponent {
	@Input() public mode: ProgressBarMode = 'determinate'

	@Input() public fileUpload: FileUpload

	@Input() public color: 'primary' | 'warn' | 'accent' = 'primary'
}
